import i18n from "../i18n";

const WorkTaskStatuses = {
  0: {
    name: i18n.global.t("work.statuses.todo"),
    color: "badge-outline",
    id: 0,
    icon: "clipboard",
  },
  1: {
    name: i18n.global.t("work.statuses.inProgress"),
    color: "bg-info text-body",
    id: 1,
    icon: "play",
  },
  2: {
    name: i18n.global.t("work.statuses.onHold"),
    color: "bg-warning text-dark",
    id: 2,
    icon: "pause",
  },
  3: {
    name: i18n.global.t("work.statuses.completed"),
    color: "bg-success text-white",
    id: 3,
    icon: "check",
  },
  4: {
    name: i18n.global.t("work.statuses.cancelled"),
    color: "bg-danger text-white",
    id: 4,
    icon: "close-circle",
  },
};

export default WorkTaskStatuses;
